import React, { useState, useEffect } from 'react';
import './navbar.css';
import { useLocation } from "react-router-dom";
//import axios from "axios";
//import { Button, ListGroup, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import Ditta_Form_Base from "./Ditta_form_base";

import {  Navigate } from 'react-router-dom';


const Ditta_form_mail = () => {

   
    const search = useLocation().search;
    const attore = new URLSearchParams(search).get('attore');
    const id = new URLSearchParams(search).get('id');
    const indice = new URLSearchParams(search).get('indice');
    const valore = new URLSearchParams(search).get('valore');

    const [show, setShow] = useState(true);

    // the alert is displayed by default
    const [show_alert, setAlert] = useState(false);

    useEffect(() => {
        console.log('+++++ USEEFFECT +++++')
        console.log('il bottone salva [ stato premuto')

        //        setTimeout(() => {
        //            setAlert(false);
        //        }, 3000);
        //        let history = useHistory();
 
    }, [show]);


    function Mostra_alert() {
        if (show_alert) {
            return <div class="alert alert-success" role="alert">
                This is a success alert with <a href="#" class="alert-link">an example link</a>. Give it a click if you like.
            </div>
        }
        if (!show) {
            console.log('sadgsdfgdsfgsdfgdsfgds')

            return <Navigate to="/url_form_ditta_uscita_form" replace={true} />

        }
    }


    return (
        <div>
    
            <div>
                {/* <p>{id} - {attore} - {indice} - {valore} </p> */}
                  {Mostra_alert()}
            </div>

            <div>
                <Ditta_Form_Base id={id} setShow={setShow} />
            </div >
        </div>
    );
}
export default Ditta_form_mail;